<template>
  <div>
    <div class="md-layout md-size-100 md-small-size-100">
      <StatCardWithIcon
        v-for="card in this.arraySales"
        :title="card.title"
        :value="card.value"
        :icon="card.icon"
        :color="card.color"
        :key="card.title"
        :filter="card.filter"
        :footer="card.footer">
      </StatCardWithIcon>
      <SplitStatCardWithIcon
        v-for="card in this.arrayTotalSummary"
        :title="card.title"
        :title-ext="card.titleExt"
        :value="card.value"
        :value-ext="card.valueExt"
        :icon="card.icon"
        :color="card.color"
        :key="card.title"
        :filter="card.filter"
        :footer="card.footer"
      >
      </SplitStatCardWithIcon>
    </div>

    <div class="md-layout boxed-category md-size-100 md-small-size-100" v-if="this.salesTabGraph.totalIncomes">
      <div class="md-layout-item md-size-50 md-small-size-100 graph-boxed" v-if="this.salesTabGraph.totalIncomes">
        <md-subheader>Income Breakdown (INC GST)</md-subheader>
        <div v-if="this.salesTabGraph.totalIncomes ? !this.salesTabGraph.totalIncomes.showChart : true" >
          <notification-card message="Not enough data to render the chart" icon="error" type="warning"></notification-card>
        </div>
        <dough-chart v-else :chart-options="graphOption" :chart-data="this.salesTabGraph.totalIncomes" :height="350"/>
      </div>

      <div class="md-layout-item md-size-50 md-small-size-100 graph-boxed" v-if="this.salesTabGraph.insuranceBreakDown">
        <md-subheader>Insurance Breakdown (INC GST)</md-subheader>
        <div v-if="this.salesTabGraph.insuranceBreakDown ? !this.salesTabGraph.insuranceBreakDown.showChart : true" >
          <notification-card message="Not enough data to render the chart" icon="error" type="warning"></notification-card>
        </div>
        <pie-chart v-else :chart-options="graphOption" :chart-data="this.salesTabGraph.insuranceBreakDown" :height="350"/>
      </div>

      <!-- Lender YIELD Breakdown -->
      <div class="md-layout-item md-size-100 md-small-size-100 graph-boxed" v-if="this.salesTabGraph.yieldBreakDown">
        <md-subheader>Lender Yield %</md-subheader>
        <div v-if="this.salesTabGraph.yieldBreakDown ? !this.salesTabGraph.yieldBreakDown.showChart : true">
          <notification-card message="Not enough data to render the chart" icon="error" type="warning"></notification-card>
        </div>
        <div class="md-layout-item md-size-100 md-small-size-100 graph-boxed" v-else>
          <bar-chart :chart-options="graphOption" :chart-data="this.salesTabGraph.yieldBreakDown" :height="350"/>
        </div>
      </div>

      <div class="md-layout-item md-size-100 md-small-size-100 graph-boxed" v-if="this.salesTabGraph.totalIncomes">
        <md-subheader>Lenders Breakdown - Total Income (INC GST)</md-subheader>
        <div v-if="this.salesTabGraph.totalIncomes ? !this.salesTabGraph.totalIncomes.showChart : true">
          <notification-card message="Not enough data to render the chart" icon="error" type="warning"></notification-card>
        </div>
        <div v-else class="apex-chart-wrapper">
          <vue-apex-charts width="100%" type="bar" :options="computedOptionsTotalIncome" :series="seriesTotalIncome"></vue-apex-charts>
        </div>
      </div>

      <div class="md-layout-item md-size-100 md-small-size-100 graph-boxed" v-if="this.salesTabGraph.lenderBreakDownNAF">
        <md-subheader>Lenders Breakdown - NAF</md-subheader>
        <div v-if="this.salesTabGraph.lenderBreakDownNAF ? !this.salesTabGraph.lenderBreakDownNAF.showChart : true">
          <notification-card message="Not enough data to render the chart" icon="error" type="warning"></notification-card>
        </div>
        <div v-else class="apex-chart-wrapper">
          <vue-apex-charts width="100%" type="bar" :options="computedOptionsNaf" :series="seriesNaf"></vue-apex-charts>
        </div>
      </div>

      <!-- BROKER Income BREAKDOWN CHART -->
      <div class="md-layout-item md-size-100 md-small-size-100 graph-boxed" v-if="this.salesTabGraph.brokerBasedIncomeData">
        <md-subheader>Broker - Income Finalized (Inc GST)</md-subheader>
        <div v-if="this.salesTabGraph.brokerBasedIncomeData ? !this.salesTabGraph.brokerBasedIncomeData.showChart : true">
          <notification-card message="Not enough data to render the chart" icon="error" type="warning"></notification-card>
        </div>
        <bar-chart v-else :chart-options="graphOption" :chart-data="this.salesTabGraph.brokerBasedIncomeData" :height="350"/>
      </div>

      <!-- POD INCOME CHART -->
      <div class="md-layout-item md-size-100 md-small-size-100 graph-boxed" v-if="this.salesTabGraph.podBasedIncomeData && this.filters.dropdown.pod == 'All'">
        <md-subheader>Pod Income Breakdown (Exclude GST)</md-subheader>
        <div v-if="this.salesTabGraph.podBasedIncomeData ? !this.salesTabGraph.podBasedIncomeData.showChart : true" >
          <notification-card message="Not enough data to render the chart" icon="error" type="warning"></notification-card>
        </div>
        <bar-chart v-else :chart-options="graphOption" :chart-data="this.salesTabGraph.podBasedIncomeData" :height="350"/>
      </div>
    </div>
  </div>
</template>

<script>
import StatCardWithIcon from "./ReportingDashboard/components/StatCardWithIcon";
import SplitStatCardWithIcon from "./ReportingDashboard/components/SplitStatCardWithIcon";
import BarChart from "./ReportingDashboard/charts/BarChart";
import LineChart from "./ReportingDashboard/charts/LineChart";
import PieChart from "./ReportingDashboard/charts/PieChart";
import DoughChart from "./ReportingDashboard/charts/DoughChart";
import NotificationCard from "../components/Cards/NotificationCard";
import GroupCard from "../components/Cards/GroupCard";
import VueApexCharts from 'vue-apexcharts'
import filters from '../components/utils/filters'

export default {
  components: {
    StatCardWithIcon,
    SplitStatCardWithIcon,
    DoughChart,
    PieChart,
    LineChart,
    BarChart,
    GroupCard,
    NotificationCard,
    VueApexCharts
  },
  props: ['salesTabStats', 'salesTabGraph', 'filters', 'roundedNaf', 'roundedTotalIncome'],
  data() {
    return {
      graphOption: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          datalabels: {
            color: 'black',
            backgroundColor: 'white',
            textAlign: 'center',
            borderRadius: 5,
          }
        },
      },
    }
  },
  computed: {
    arraySales() {
        const arraySales = this.salesTabStats.filter(function(element) {
          return element.title !== 'MVI Income' && element.title !== 'WTY Income'
        });
        return arraySales;
    },
    arrayTotalSummary() {
        const arrayTotalSummary = this.salesTabStats.filter(function(element) {
          return element.title === 'MVI Income' || element.title === 'WTY Income'
        });
        return arrayTotalSummary;
    },
    computedOptionsNaf() {
      return {
        chart: {
          type: 'bar',
          animations: {
            speed: 200
          },
          toolbar: {
            show: true
          },
        },
        plotOptions: {
          bar: {
            distributed: true,
            horizontal: true,
            dataLabels: {
              position: 'bottom'
            },
          }
        },
        dataLabels: {
          enabled: true,
          textAnchor: 'start',
          offsetX: 0,
          style: {
            colors: ['#000000']
          },
          formatter: function (value) {
            return filters["currency"](value).replace(".00", "");
          }
        },
        xaxis: {
          categories:  this.salesTabGraph.lenderBreakDownNAF ? this.salesTabGraph.lenderBreakDownNAF.labels : []
        },
        theme: {
          palette: 'palette1'
        }
      }
    },
    computedOptionsTotalIncome() {
      return {
        chart: {
          type: 'bar',
          animations: {
            speed: 200
          },
          toolbar: {
            show: true
          },
        },
        plotOptions: {
          bar: {
            distributed: true,
            horizontal: true,
            dataLabels: {
              position: 'bottom'
            },
          }
        },
        dataLabels: {
          enabled: true,
          textAnchor: 'start',
          offsetX: 0,
          style: {
            colors: ['#000000']
          },
          formatter: function (value) {
            return filters["currency"](value).replace(".00", "");
          }
        },
        xaxis: {
          categories: this.salesTabGraph.lenderBreakDown ? this.salesTabGraph.lenderBreakDown.labels : []
        },
        theme: {
          palette: 'palette1'
        }
      }
    },
    seriesNaf() {
      return [
        {
          name: "NAF",
          data: this.roundedNaf,
        }
      ]
    },
    seriesTotalIncome() {
      return [
        {
          name: "Total Income (GST Inc)",
          data: this.roundedTotalIncome
        }
      ]
    },
  },
  methods: {
    ...filters
  },
  filters: {
    ...filters
  },
  created() {
  }
}
</script>
<style scoped lang="scss">
.filter-box {
  margin-top: 10px;
}

.application-popup-overlay {
  opacity: 0.7;
  background: #000;
  width: 100%;
  height: 100%;
  z-index: 5;
  top: 0;
  left: 0;
  position: fixed;
}

.application-popup {
  position: absolute;
  background: white;
  border: 1px grey solid;
  overflow-y:scroll;
  overflow-x:hidden;
  height: 80%;
  z-index: 6;
  left: 10%;
  right: 10%;
  padding-bottom: 20px;
}

.apex-chart-wrapper {
  height: auto;
}
</style>
